import React from 'react';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import RecoverKeysDialog from './RecoverKeysDialog';

type Props = {
   onClose: () => void;
};
const SSH_PUBLIC_KEY_PROPS = {ssh: true, objectType: DiplomatObjectType.enum.SSH_PUBLIC_KEY};
export const RecoverSSHPublicKeysDialog = ({onClose}: Props) => {
   return <RecoverKeysDialog data={SSH_PUBLIC_KEY_PROPS} onClose={onClose} />;
};

const SSH_KEY_PAIR_PROPS = {ssh: true, objectType: DiplomatObjectType.enum.SSH_KEY};
export const RecoverSSHKeyPairsDialog = ({onClose}: Props) => {
   return <RecoverKeysDialog data={SSH_KEY_PAIR_PROPS} onClose={onClose} />;
};
